export default (el) => {

  const $html = $('html'),
        $siteHeaderSearch = $(el),
        $searchOpen = $('.js-search-open'),
        $input = $('.js-search-input'),
        $btn = $('.js-search-submit')
  ;

  $searchOpen.on('click', () => {
    $html.attr('data-search', 'open');
    $siteHeaderSearch.attr('aria-hidden', 'false');
    setTimeout(() => {
      $input.trigger('focus');
    }, 300);
  });

  $('.js-search-close, .js-blocker').on('click', () => {
    $html.attr('data-search', 'closed');
    $siteHeaderSearch.attr('aria-hidden', 'true');
    setTimeout(() => {
      $searchOpen.trigger('focus');
    }, 500);
  });

  $(document).on('keydown', ({ key }) => {
    if (key === 'Esc' || key === 'Escape') {
      $html.attr('data-search', 'closed');
      $siteHeaderSearch.attr('aria-hidden', 'true');
    }
  });

  $input.on('input', ({ currentTarget }) => {
    $(currentTarget).val() ? $btn.prop('disabled', false) : $btn.prop('disabled', true);
  });

};
